import { useEffect, useRef, useState } from "react";
import { animated, useSpring } from "react-spring";

import { springConfigs } from "../../../constants/springConfigs";
import { DelayRender } from "../../../hooks/hooks";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { MenuRectangleButton } from "./MenuRectangleButton";
import AssetContainer from "./AssetContainer";
import MenuColumnNumber from "./MenuColumnNumber";
import MenuSubText from "./MenuSubText";
import MenuSubTitle from "./MenuSubTitle";
import MenuTitle from "./MenuTitle";
import { MenuCaret } from "./MenuCaret";
import { SVGCircle } from "./SVGCircle";
import { WhiteLine } from "../../shared/WhiteLine";

export const MenuColumn = ({
  active,
  setActive,
  id,
  number,
  menuTitle,
  subTitle,
  rectangleButtonText,
  bulletPoints,
  subText,
  svgComponent,
  showColumnContentDelay,
  onCurtainStart,
  curtainTo,
  videoStyle,
  videoStartSecond,
}: any) => {
  const ref = useRef<any>(null);
  useEffect(() => {
    if (active && ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [active]);

  const [appear, appearSet] = useState(true);

  /* background illumination */
  const { MenuColumnBackground } = useSpring({
    from: { MenuColumnBackground: "#0005" },
    to: {
      MenuColumnBackground: !appear && !active ? "#0005" : "#0000",
    },
    // config: springConfigs.backgroundTransitions,
    onRest: () => {
      if (appear) appearSet(false);
    },
    delay: appear ? showColumnContentDelay : 0,
  });

  const { horizontal, h } = useWindowSize();

  return (
    <div
      id="MenuColumn"
      ref={ref}
      style={{
        // minWidth: horizontal ? "23vw" : "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",
        display: "flex",
      }}
      onMouseEnter={() => {
        setActive(id);
      }}
      onTouchStart={() => {
        setActive(id);
      }}
      onClick={() => {
        setActive(id);
      }}
    >
      {!appear && (
        <AssetContainer
          {...{ active, menuTitle, id, videoStyle, videoStartSecond }}
        />
      )}
      {/* column container */}
      <animated.div
        id="column-container"
        style={{
          flex: "1 0 0",
          flexDirection: "column",
          padding: horizontal ? `0 ${h(3)}` : `0 ${h(3)}`,
          display: "grid",
          gridTemplateRows: "35% 53% 12%",
          position: "relative",
          background: MenuColumnBackground,
        }}
      >
        {/* TODO Replace wth spring chain */}
        <DelayRender delay={showColumnContentDelay}>
          <div id="row1">
            <MenuColumnNumber {...{ number, active }} />
            <SVGCircle {...{ active, svgComponent }} />
          </div>

          <div id="row2" style={{ width: "100%" }}>
            <MenuTitle {...{ menuTitle }} />
            <MenuSubTitle {...{ active, appear, subTitle }} />
            <MenuSubText
              {...{
                active,
                subText,
                bulletPoints,
              }}
            />
          </div>

          <div id="row3" {...{ style: { position: "relative" } }}>
            {active && !appear && (
              <MenuRectangleButton
                {...{
                  rectangleButtonText,
                  curtainTo,
                  onCurtainStart,
                }}
              />
            )}
            <MenuCaret {...{ active }} />
          </div>
        </DelayRender>
      </animated.div>
      <WhiteLine />
    </div>
  );
};
